import tw, { styled } from "twin.macro";

export const MenuButton = styled.div<{ disabled?: boolean }>(({ disabled }) => [
  tw`flex flex-1 items-center cursor-pointer text-sm font-medium`,
  disabled && tw`pointer-events-none text-greyscale`,
]);
